import React from 'react'
import clsx from 'clsx'
import { TextareaAutosize } from '@mui/material'
import { useAppDispatch, useAppSelector } from '@SonarCX/hooks/redux'

import BaseModal from '@SonarCX/components/molecules/ChatModals/BaseModal2'
import Button from '@SonarCX/components/atoms/Button2'

import {
  selectCustomFieldGroups,
  createCustomFieldGroup
} from '@SonarCX/slices/customFields/groups'
import { useBreakpoint } from '@SonarCX/providers/BreakpointProvider'
import useStyles from './styles'

type NewGroupModalProps = {
  title: string
  object_type: APICustomFieldGroup['object_type']
  type_id: APICustomFieldGroup['type_id']
  onClose: () => void
}

const NewGroupModal: React.FC<NewGroupModalProps> = ({
  title,
  object_type,
  type_id,
  onClose
}) => {
  const dispatch = useAppDispatch()

  const { groups } = useAppSelector(selectCustomFieldGroups)

  const { isMedium } = useBreakpoint()

  const [name, setName] = React.useState('')
  const [description, setDescription] = React.useState('')

  const nextOrder = React.useMemo(() => {
    let highest = 0
    groups[object_type].forEach(group => {
      if (group.order >= highest) {
        highest = group.order + 10
      }
    })
    return highest
  }, [groups, object_type])

  const classes = useStyles()

  const handleSave = React.useCallback(() => {
    const desc = description.trim()
    const newGroup: CustomFieldGroupPOSTUpdate = {
      object_type,
      type_id: type_id === 'null' ? null : type_id,
      title: name,
      description: desc === '' ? null : desc,
      order: nextOrder,
      field_ids: []
    }
    dispatch(createCustomFieldGroup(newGroup))
    onClose()
  }, [object_type, type_id, name, description, nextOrder, dispatch, onClose])

  return (
    // @ts-ignore
    <BaseModal
      open
      title={`Add New ${title} Group`}
      onClose={onClose}
      PaperProps2={{
        style: {
          padding: '20px 16px 24px 16px',
          border: '1px solid #C6C6C6',
          borderRadius: '4px',
          width: isMedium ? 'calc(100% - 4rem)' : '100%',
          maxWidth: isMedium ? 'unset' : '360px',
          height: isMedium && `auto`,
          maxHeight: isMedium && 'unset',
          minHeight: isMedium && 'auto'
        }
      }}
      classes={{ title: classes.modalTitle, close: classes.modalClose }}
    >
      <div className={classes.name}>Title</div>

      <input
        autoFocus
        value={name}
        onChange={e => setName(e.target.value)}
        placeholder='Enter group name'
        className={classes.input}
      />

      <div className={classes.name}>Description</div>

      <TextareaAutosize
        minRows={1}
        maxRows={5}
        value={description}
        onChange={e => setDescription(e.target.value)}
        placeholder='Enter group description'
        className={clsx(classes.input, classes.textArea)}
      />

      <Button
        onClick={handleSave}
        disabled={name.trim().length === 0}
        className={classes.button}
      >
        Add Group
      </Button>
    </BaseModal>
  )
}

export default NewGroupModal
